import type {SVGProps} from 'react'

const X = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
        <rect width="24" height="24" rx="7" fill="black" />
        <path
            d="M13.3333 10.9287L18.5459 5H17.3111L12.7831 10.1468L9.1692 5H5L10.4661 12.7836L5 19H6.2348L11.0135 13.5637L14.8308 19H19M6.68047 5.91111H8.57747L17.3102 18.1337H15.4127"
            fill="white"
        />
    </svg>
)
export default X
